import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class MailService {

  private url = environment.do_services_sb_url;
  private mailToAdminUrl = 'generic/mailToAdmin';

  constructor(private http: HttpClient) { }
  
  mailToAdmin(mailObject: string): Observable<any> {
    return this.http.post(this.url + this.mailToAdminUrl, mailObject, { responseType: 'text' }).pipe(
      map((response: any) => {
        const run = response;
        return run;
      }),
      catchError((e: any) => {
        if(e.status === 400) {
          return throwError(e.status);
        } else if(e.status === 504) {
          return throwError(e.status);
        } else if(e.status === 500) {
          return throwError(e.status);
        }
        throw new Error("Unhandled status code");
      })
    );
  }

}